import styledComp from 'styled-components';
import { FiberManualRecord as FiberManualRecordIcon } from '@mui/icons-material';
import { IconButton, TableRow } from '@mui/material';
import { statusToColorMap } from './statusToColorMap';
import { ActionStatus } from '../../../api/vault/assetStatus/interfaces';
import { Styling, Colors } from '../../../constants';
import VaultButton from '../VaultButton';

export const StatusContainer = styledComp.div`
  align-items: center;
  display: flex;
  margin: 0 auto;
`;

interface IStatusIconProps {
  status: ActionStatus;
}
export const StatusIcon = styledComp(FiberManualRecordIcon) <IStatusIconProps>`
  color: ${(props) => (statusToColorMap.get(props.status))};
  margin-right: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const StyledBodyTableRow = styledComp(TableRow)`
  cursor: pointer;
  &:hover {
    background-color: ${Colors.PAPER_DARKER_1};
  }
`;

export const RowActionButtonContainer = styledComp.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const JobDetailsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  p {
    height: 24px;
    display: flex;
    align-items: center;
  }
  span {
    font-weight: bold;
    display: inline-block;
    width: 150px;
    margin-bottom: 5px;
  }
`;

export const TabeleCellDateContent = styledComp.div`
  display: flex;
  flex-wrap: wrap;
  &:first-child {
    margin-right: 5px;
  }
`;

export const TableCellContent = styledComp.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledClipperButton = styledComp(VaultButton)`
  border-radius: 50%;
  &:not([disabled]):hover {
    background-color: ${Colors.WHITE_90};
  }
`;

export const StyledDeleteIcon = styledComp(IconButton)`
  svg {
    margin: 0;
  }
  &:hover svg { 
    fill: ${Colors.RED_1}; 
  }
`;
